import { Typography, styled } from 'opensolar-ui'
import React from 'react'
import { useTranslate } from 'react-admin'
import { makeOpenSolarStyles } from 'themes/makeOpenSolarStyles'
import { getHighlightedText } from './MenuItemLinkText'

const ChipContainer = styled('div', { name: 'OSMenuCategoryItemChipContainer' })({
  maxWidth: '100%',
  width: '100%',
  '& .MuiChip-root': {
    maxWidth: '100%',
    width: '100%',
    height: 'auto',
    justifyContent: 'flex-start',
  },
  '& .MuiChip-label': {
    whiteSpace: 'normal',
    wordBreak: 'break-word',
    overflow: 'visible',
    textOverflow: 'clip',
    display: 'block',
  },
})

const useStyles = makeOpenSolarStyles(
  (theme) => ({
    icon: {
      height: 24,
      width: 20,
      marginRight: 10,
      color: 'inherit',
    },
    title: {
      flexGrow: 1,
      margin: 0,
      fontSize: 16,
      fontWeight: 'normal',
      display: 'flex',
      alignItems: 'center',
    },
    wrapper: {
      borderRadius: 2,
      padding: '15px 10px',
      cursor: 'pointer',
      transition: '0.3s',
      zIndex: 1,
      '&:hover': {
        background: '#F5F5F5',
      },
    },
    warningIcon: {
      marginLeft: '8px',
      display: 'inline-flex',
      alignItems: 'center',
    },
    itemRow: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'start',
      alignItems: 'start',
      gap: 12,
    },
    iconContainer: {
      display: 'flex',
      width: 22,
    },
    infoContainer: {
      display: 'flex',
      flexGrow: 1,
      flexDirection: 'column',
      gap: 4,
      minWidth: 0,
    },
    titleArrowRow: {
      display: 'flex',
      flexGrow: 1,
      alignItems: 'center',
      justifyContent: 'space-between',
      minWidth: 0,
      gap: 4,
    },
    titleContainer: {
      display: 'flex',
      alignItems: 'center',
      minWidth: 0,
      flex: 1,
    },
    arrowContainer: {
      display: 'flex',
      flexShrink: 0,
    },
  }),
  { name: 'OSMenuCategoryItem' }
)

export type CategoryItemPropsType = {
  Icon: React.ReactElement
  title: string
  id: string
  handleClick(): void
  ArrowIconNode?: React.ReactNode
  warningIcon?: React.ReactNode
  chip?: React.ReactNode
  highlightText?: string
}

const CategoryItem = ({
  Icon,
  title,
  id,
  handleClick,
  ArrowIconNode,
  warningIcon,
  chip,
  highlightText,
}: CategoryItemPropsType) => {
  const classes = useStyles()
  const translate = useTranslate()
  const translatedTitle = translate(title)

  return (
    <div className={classes.wrapper} id={id} onClick={handleClick}>
      <div className={classes.itemRow}>
        <div className={classes.iconContainer}>{React.cloneElement(Icon)}</div>
        <div className={classes.infoContainer}>
          <div className={classes.titleArrowRow}>
            <div className={classes.titleContainer}>
              <Typography textVariant="body2" color="textSecondary" style={{ wordBreak: 'break-word' }}>
                {getHighlightedText(translatedTitle, highlightText)}
              </Typography>
              {warningIcon && <span className={classes.warningIcon}>{warningIcon}</span>}
            </div>
            {!!ArrowIconNode && <span className={classes.arrowContainer}>{ArrowIconNode}</span>}
          </div>
          {chip && <ChipContainer>{chip}</ChipContainer>}
        </div>
      </div>
    </div>
  )
}

export default CategoryItem
